<main class="main">
    <div class="main-wrapper">
      <section class="padding-first about1" id="about_us">
        <div class="container">

          <a [routerLink]="['/news']" [routerLinkActive]="['active']" class="more">
            <div class="icon-back">
              <span>Back</span>
            </div>
          </a>


          <div>
            <div class="bl-rows">
              <div class="text">
                <h2>Gennius XYZ Appoints Laura Gabrysiak Gomez as Vice President of AI and Analytics</h2>

                <span>By Gennius March 17, 2025</span>
              </div>
              <div class="img">
                <img src="./assets/img/gennius/bg-inside-notice15.webp">
              </div>
            </div>
          </div>

          <div class="bl-center">

            <p>
                <strong>Miami, USA</strong>, Gennius XYZ is strengthening its commitment to AI-driven innovation with the appointment of <strong>Laura Gabrysiak Gomez</strong> as <strong>Vice President of AI and Analytics.</strong>
                With over 13 years of experience in <strong>data science, advanced analytics, and MLOps,</strong> Laura will spearhead the development of AI-powered solutions designed to
                <strong>enhance client engagement, optimize partner revenues, and drive business impact across industries.</strong>
            </p>

            <p>
            “Laura’s leadership will be instrumental in advancing our <strong>Digital Engagement Platform,</strong> a next-generation solution that seamlessly integrates  <strong>AI, Web3, Virtual Cards and digital assets</strong>
            into loyalty and engagement solutions. By leveraging data-driven intelligence, she will refine predictive analytics, <strong>boost customer lifetime value,</strong> and unlock new monetization pathways for our clients
            and partners” Said Ruben Salazar Genovez, CEO of Gennius XYZ.
            </p>

            <p>Previously, Laura led transformative AI and analytics initiatives at <strong>Visa,</strong> where she developed scalable frameworks that <strong>enhanced operational efficiency and accelerated revenue growth.</strong>
                Her expertise in building <strong>end-to-end AI solutions </strong> has empowered organizations to make smarter, faster, and more impactful business decisions. <br>
                At Gennius XYZ, she will drive <strong>AI strategy and innovation</strong>  to ensure our partners-including banks, fintechs, and digital platforms-can harness the power of machine learning to create personalized, real-time customer experiences. Her appointment reinforces our mission to
                <strong>turn data into actionable insights that fuel engagement, retention, and revenue expansion.</strong>
            </p>

            <p>Laura’s addition marks a <strong> strategic leap forward</strong> in our AI capabilities, further strengthening our position as a <strong>key partner in the evolving digital economy.</strong> We are thrilled to welcome her to the team and look forward to her leadership in shaping the future of AI-powered financial and digital engagement solutions.
            </p>

            <p>For more information about <strong>Gennius XYZ</strong>, please visit <a
                href="https://gennius.xyz/"><strong>www.gennius.xyz</strong></a>.</p>


          </div>

        </div>
      </section>


    </div>
</main>
<app-footer></app-footer>
